import { render, staticRenderFns } from "./ProvisionForm.vue?vue&type=template&id=633145f8"
import script from "./ProvisionForm.vue?vue&type=script&lang=ts"
export * from "./ProvisionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports